export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const START_LOADING_ROLES_PERMISSIONS = "START_LOADING_ROLES_PERMISSIONS";
export const ERROR_LOADING_ROLES_PERMISSIONS = "ERROR_LOADING_ROLES_PERMISSIONS"
export const STOP_LOADING_ROLES_PERMISSIONS = "STOP_LOADING_ROLES_PERMISSIONS";
export const RESET_DATA = "RESET_DATA";
